import { ActionContext, ActionTree, GetterTree, MutationTree } from 'vuex';
import { ID, parseID } from '../../dndg/helpers';
import { get, post, del, ApiResult, checkResult } from '../../dndg/helpers/api';
import { State } from '../store';
import { RegistrationData } from '../../model/api';

// Actions

type RegistrationDataApiResult = ApiResult<RegistrationData>;

export async function loadRegistrationData(ctx: ActionContext<State,any>) {
    const endpoint = `/_api/v1/registration`;

    let result = await get(endpoint).then(res => res.data as RegistrationDataApiResult);
    return checkResult(ctx, result);
}

export async function updateRegistrationData(ctx: ActionContext<State,any>, args: { data: RegistrationData }) {
    const endpoint = `/_api/v1/registration`;

    let result = await post(endpoint, args.data).then(res => res.data as ApiResult<void>);
    return checkResult(ctx, result);
}


// WEBPACK FOOTER //
// ./src/app/signup/actions.ts